<template>
  <footer class="d-flex flex-row justify-content-between">
    <p>Merci d'utiliser cet outil d'AVAP</p>
    <p>Version 1.0.0</p>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
footer{
  & > p{
    margin-bottom: 0;
  }
  & > p:first-child{}
  & > p:last-child{
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue